export const TAX_RATE = {
    PH: 0.12,
}